import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getOfferPreFilledData } from '../../selectors';
import PropTypes from 'prop-types';
import Congrat from './congrat';
import PersonlizeLoan from './personlizeloan';
import { updateStandardDataLayerAttributes, setPageNameSiteSection } from "../../analytics/adobe/index";
import { personalizeDataLayer } from "../../analytics/adobe/dataLayerValues";

export class LoanCustomize extends React.Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { pageName, siteSection }=personalizeDataLayer;
    updateStandardDataLayerAttributes(setPageNameSiteSection(pageName, siteSection), true);
  }

  render() {
    return (
      <PersonlizeLoan crossSellPersonalizedQuote={this.props.offerPreFilled.crossSellPersonalizedQuote}
        maxAmount={this.props.offerPreFilled.offerDetails.maxAmount}
        minAmount={this.props.offerPreFilled.offerDetails.minAmount}
        aprs={this.props.offerPreFilled.offerDetails.aprs}
        rewardEnabled={this.props.offerPreFilled.rewardEnabled}
        rewardDisplayCurrency={this.props.offerPreFilled.rewardDisplayCurrency}
        currencyPrefix={this.props.offerPreFilled.currencyPrefix}
        mover={this.props.history}/>
    );
  }
}

const mapStateToProps = (state) => ({
  offerPreFilled: getOfferPreFilledData(state)
});

const mapDispatchToProps = dispatch => {
  return ({});
};

export default connect(mapStateToProps, mapDispatchToProps)(LoanCustomize);
